/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} What_Is_Land_Skin_DescriptionInputs */

const en_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once applied, this Land Style will give your Forest land a whole new look!`)
};

const ar_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بمجرد تطبيقه، سيمنح نمط الأرض هذا أرض Forest مظهرًا جديدًا تمامًا!`)
};

const de_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal angewendet, verleiht dieser Land-Stil dem Land in Forest ein völlig neues Aussehen!`)
};

const es_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Una vez aplicado, este Estilo de terreno le dará un aspecto totalmente nuevo al terreno de Forest!`)
};

const fr_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois appliqué, ce Style de sol donnera une toute nouvelle apparence au sol de Forest !`)
};

const it_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una volta applicato, questo Stile del terreno darà un aspetto completamente nuovo al terreno di Forest!`)
};

const ja_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このランドスタイルを適用すると、Forestの土地がまったく新しい見た目に変わります！`)
};

const ko_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 랜드 스타일을(를) 적용하면 Forest의 땅이 완전히 새로운 모습으로 바뀌어요!`)
};

const pt_br_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma vez aplicado, este Estilo de terreno dará um visual totalmente novo ao terreno do Forest!`)
};

const ru_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После применения этот Стиль земли полностью преобразит землю в Forest!`)
};

const th_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อใช้แล้ว สไตล์พื้นดินนี้จะทำให้พื้นดินใน Forest เปลี่ยนโฉมใหม่หมด!`)
};

const tr_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulandıktan sonra bu Arazi Türü, Forest'taki araziye yepyeni bir görünüm kazandıracak!`)
};

const zh_cn_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用“土地皮肤”后，森林土地将换上全新造型！`)
};

const zh_tw_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套用「土地造型」之後，森林土地將會換上全新的造型！`)
};

/**
* | output |
* | --- |
* | "Once applied, this Land Style will give your Forest land a whole new look!" |
*
* @param {What_Is_Land_Skin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const what_is_land_skin_description = /** @type {((inputs?: What_Is_Land_Skin_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<What_Is_Land_Skin_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_what_is_land_skin_description(inputs)
	if (locale === "ar") return ar_what_is_land_skin_description(inputs)
	if (locale === "de") return de_what_is_land_skin_description(inputs)
	if (locale === "es") return es_what_is_land_skin_description(inputs)
	if (locale === "fr") return fr_what_is_land_skin_description(inputs)
	if (locale === "it") return it_what_is_land_skin_description(inputs)
	if (locale === "ja") return ja_what_is_land_skin_description(inputs)
	if (locale === "ko") return ko_what_is_land_skin_description(inputs)
	if (locale === "pt_br") return pt_br_what_is_land_skin_description(inputs)
	if (locale === "ru") return ru_what_is_land_skin_description(inputs)
	if (locale === "th") return th_what_is_land_skin_description(inputs)
	if (locale === "tr") return tr_what_is_land_skin_description(inputs)
	if (locale === "zh_cn") return zh_cn_what_is_land_skin_description(inputs)
	return zh_tw_what_is_land_skin_description(inputs)
});